import CasestudyService from 'src/modules/casestudy/casestudyService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';
import issuesListActions from 'src/modules/issues/list/issuesListActions';

const prefix = 'CASESTUDY_FORM';

const casestudyFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: casestudyFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await CasestudyService.find(id);
      }

      dispatch({
        type: casestudyFormActions.INIT_SUCCESS,
        payload: record,
      });

      dispatch(issuesListActions.doFetchAll());

    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: casestudyFormActions.INIT_ERROR,
      });

      getHistory().push('/casestudy');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: casestudyFormActions.CREATE_STARTED,
      });

      await CasestudyService.create(values);

      dispatch({
        type: casestudyFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.casestudy.create.success'),
      );

      getHistory().push('/casestudy');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: casestudyFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: casestudyFormActions.UPDATE_STARTED,
      });

      await CasestudyService.update(id, values);

      dispatch({
        type: casestudyFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.casestudy.update.success'),
      );

      getHistory().push('/casestudy');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: casestudyFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default casestudyFormActions;
